import React from "react";
import Navbar from "./common/Navbar";
import SubFooter from "./common/SubFooter";
import Footer from "./common/Footer";
import Education from "./inner-components/Education";
import { EducationArr } from "./data/EducationData";

const Academics = () => {
  return (
    <React.Fragment>
      <main className="flex-shrink-0">
        <Navbar />
        <div className="container px-5">
          <div className="text-center mb-5">
            <h1 className="display-6 fw-bolder mb-0">
              <span className="text-gradient d-inline">Academics</span>
            </h1>
          </div>
          <div className="row gx-5 justify-content-center">
            <div className="col-lg-12 col-xl-12 col-xxl-10">
              <section>
                {EducationArr.map((item) => (
                  <Education key={item} detail={item} />
                ))}
              </section>
            </div>
          </div>
        </div>
      </main>
      <SubFooter />
      <Footer />
    </React.Fragment>
  );
};

export default Academics;
